import {useNavigate, useParams} from "react-router-dom";

export function gpn(Component) {
    return (props) => (
        <Component {...props} params={useParams()} navigate={useNavigate()}/>
    );
}